/**
 * Transportadoras del módulo Manifiestos (una card por ítem)
 * Colores tomados de logos / tokens del proyecto (tailwind: red-colvanes, blue-envia)
 */
import type { ManifiestoCarrierConfig } from '../../types/manifiestos'

export const MANIFIESTOS_CARRIERS: ManifiestoCarrierConfig[] = [
  {
    id: 'envia-colvanes',
    label: 'Envía Colvanes',
    transportadoraValue: 'envía',
    description: 'Guías Envía / Colvanes listas para despacho',
    /** Rojo Colvanes / Envía (logo + token red-colvanes) */
    iconColorClass: 'text-red-colvanes',
    iconBgClass: 'bg-red-50',
    aliases: ['envía', 'envia', 'envía colvanes', 'envia colvanes', 'colvanes'],
  },
  {
    id: 'coordinadora',
    label: 'Coordinadora',
    transportadoraValue: 'coordinadora',
    description: 'Pedidos Coordinadora listos para despacho',
    iconColorClass: 'text-[#005DAA]',
    iconBgClass: 'bg-blue-50',
    aliases: ['coordinadora'],
  },
  {
    id: 'interrapidisimo',
    label: 'Interrapidisimo',
    transportadoraValue: 'inter_rapidisimo',
    description: 'Pedidos Interrapidisimo listos para despacho',
    iconColorClass: 'text-gray-900',
    iconBgClass: 'bg-gray-100',
    aliases: [
      'inter_rapidisimo',
      'interrapidisimo',
      'inter rapidisimo',
      'inter rapidísimo',
    ],
  },
  {
    id: '99minutos',
    label: '99 Minutos',
    transportadoraValue: 'noventa9minutos',
    description: 'Pedidos 99 Minutos listos para despacho',
    iconColorClass: 'text-[#8DC63F]',
    iconBgClass: 'bg-lime-50',
    aliases: ['noventa9minutos', '99minutos', '99 minutos', 'noventa9minutos'],
  },
  {
    id: 'tcc',
    label: 'TCC',
    transportadoraValue: 'tcc',
    description: 'Pedidos TCC listos para despacho',
    iconColorClass: 'text-yellow-500',
    iconBgClass: 'bg-yellow-50',
    aliases: ['tcc'],
  },
  {
    id: 'el-socio',
    label: 'El Socio',
    transportadoraValue: 'El_Socio',
    description: 'Pedidos El Socio listos para despacho',
    iconColorClass: 'text-amber-700',
    iconBgClass: 'bg-amber-50',
    aliases: ['el_socio', 'el socio'],
  },
  {
    id: 'meli',
    label: 'Meli',
    transportadoraValue: 'meli',
    description: 'Pedidos Meli listos para despacho',
    iconColorClass: 'text-mercadol',
    iconBgClass: 'bg-yellow-50',
    aliases: ['meli'],
  },
  {
    id: 'falabella',
    label: 'Falabella',
    transportadoraValue: 'falabella',
    description: 'Pedidos Falabella listos para despacho',
    iconColorClass: 'text-indigo-700',
    iconBgClass: 'bg-indigo-50',
    aliases: ['falabella'],
  },
]
